<template>
  <div class="form login" :class="{ mobile_flag: mobile_flag }">
    <!-- 验证码 -->
    <el-form v-show="nwxLogin == 3" style="display: block">
      <!-- 验证码title -->
      <div class="input_top" v-show="!qrShow_er">
        <div>
          {{
            this.Changebutton == 0
              ? "验证码注册/登录"
              : this.Changebutton == 1
              ? "验证码登录"
              : "验证码注册"
          }}
        </div>
      </div>
      <!-- 验证码手机号 -->
      <el-row v-show="!qrShow_er">
        <el-col>
          <el-form-item style="text-align: center">
            <el-input
              class="custom-input"
              autofocus="true"
              placeholder="输入您的手机号"
              @blur="phoneaa"
              v-model="shuru.phonea"
              clearable
            ></el-input>
            <!-- 密码重写提示信息  密码填写错误提示信息 共4个 -->
            <div class="el-form-item__error" style="text-indent: 7px">
              {{ cuowuspan.phonea }}
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 短信登陆 填写短信部分 -->
      <el-row v-show="!qrShow_er">
        <el-col :span="1">
          <el-form-item></el-form-item>
        </el-col>
        <el-col class="custom-input">
          <el-form-item>
            <el-input
              color=".el-checkbox"
              style="display: block; width: 237px; margin-left: 7px"
              placeholder="输入验证码"
              @blur="Verificationa"
              v-model="shuru.Verification"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="warning"
              :disabled="disabled || shuru.phonea.length != 11"
              @click="send"
              @keyup.enter="focus_botton"
              :class="
                shuru.phonea.length != 11
                  ? 'yzm'
                  : sends != '获取验证码'
                  ? 'yzm'
                  : 'Obtain'
              "
              >{{ sends }}</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 登录 -->
      <el-row v-show="!qrShow_er">
        <el-col>
          <el-form-item>
            <el-button
              type="warning"
              round
              @click="SignIn_YZM"
              :class="this.anniu == false ? 'elbutton_pt_er' : 'elbutton_pt'"
              :style="{ color: this.Verification !== '' ? 'black' : '' }"
              ref="elbottomnext"
            >
              {{
                this.Changebutton == 0
                  ? "注册/登录"
                  : this.Changebutton == 1
                  ? "登录"
                  : "下一步"
              }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 微信登录 -->
      <template v-if="nwxLogin_son == 1">
        <div class="nsspac" v-show="!qrShow_er">
          <!-- 微信图标 -->
          <div class="nsspac_one">
            <i
              v-show="!qrShow"
              class="iconfont wx"
              :class="{ wxActive: hoved }"
              @mouseenter="enter"
              @mouseleave="leave"
              @click="wxzf_er"
              >&#xe63e;</i
            >
          </div>
          <div style="color: #fff">微信登录</div>
        </div>
      </template>
      <!-- <div id="login_fater"> -->
      <div
        id="password_wx_one"
        :style="{
          height: qrShow_er ? '390px' : '0px',
          width: '250px',
          textAlign: left,
        }"
      >
        <!-- <button @click="Refresh">刷新二维码</button> -->
        <iframe
          class="iframe"
          src="https://open.weixin.qq.com/connect/qrconnect?appid=wx737bc9eb54d88878&scope=snsapi_login&redirect_uri=https%3A%2F%2Fwww.haixingcloud.com%3A8000%2Fapi%2Fsns%2Fcallback&state=wechat&login_type=jssdk&self_redirect=false&styletype=&sizetype=&bgcolor=&rst=&style=white&href=data:text/css;base64,QGNoYXJzZXQgInV0Zi04IjsKaWZyYW1le3dpZHRoOiAyNTBweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGV7IHdpZHRoOiAyNTBweDt9Ci53YWl0aW5nLnBhbmVsQ29udGVudHt3aWR0aDogMjUwcHg7fQouaW1wb3dlckJveCAudGl0bGUgewogICAgdGV4dC1hbGlnbjogY2VudGVyOwogICAgZm9udC1zaXplOiAyMHB4OwogICAgdGV4dC1pbmRlbnQ6IC00N3B4Owp9Ci5pbXBvd2VyQm94IC5pbmZvIHsKICAgIHdpZHRoOiAyNTBweDsKICAgIG1hcmdpbjogMCBhdXRvOwp9Ci5pbXBvd2VyQm94IC5zdGF0dXNfdHh0IHsKICAgIGRpc3BsYXk6IGlubGluZS1ibG9jazsKICAgIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7CiAgICBtYXJnaW4tcmlnaHQ6IC0xNHB4Owp9"
        ></iframe>
      </div>
    </el-form>

    <!-- 帐号密码 -->
    <el-form v-show="nwxLogin == 4">
      <!-- 密码登录 title提示信息 -->
      <div class="input_top" v-show="!qrShow">
        <div>密码登录</div>
      </div>
      <!-- 账户框 "手机号码"-->
      <el-row v-show="!qrShow">
        <el-col>
          <el-form-item>
            <el-input
              class="custom-input"
              placeholder="输入手机号码/用户名"
              @blur="phoneaaa"
              v-model="shuru.phone"
            ></el-input>
            <div class="el-form-item__error">{{ cuowuspan.phone }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 密码框 password -->
      <el-row v-show="!qrShow">
        <el-col>
          <el-form-item>
            <el-input
              class="custom-input"
              placeholder="请输入密码"
              @blur="passa"
              v-model="shuru.pass"
              show-password
            ></el-input>
            <div class="el-form-item__error">{{ cuowuspan.pass }}</div>
          </el-form-item>
        </el-col>
        <div class="rpwd" @click="resetPassword">忘记密码?</div>
      </el-row>

      <!-- 忘记密码 -->
      <!-- <el-row class="forget" v-show="!qrShow">
        <el-col :span="12">
          <el-checkbox v-model="bLogin1">记住密码</el-checkbox>
        </el-col>
      </el-row>-->
      <!-- 确定登录按钮 button -->
      <el-row v-show="!qrShow">
        <el-col>
          <el-form-item>
            <el-button
              class="customBtn"
              type="warning"
              round
              @click="SignIn_Password"
              :style="
                shuru.pass != '' && shuru.phone != ''
                  ? 'border-radius:5px;display:block;width:237px;height:40px;margin:0 auto;background-image: linear-gradient(270deg,rgba(244, 201, 29, 1) 0%,rgba(255, 242, 130, 1) 100%); color: black;'
                  : 'border-radius:5px;display:block;width:237px;height:40px;margin:0 auto;background-color:#A6A9AF; border: 1px solid #A6A9AF; color: #ffffff8a !important;'
              "
              >登录</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 微信登录 -->
      <template v-if="nwxLogin_son == 1">
        <div class="nsspac" v-show="!qrShow">
          <!-- 微信图标 -->
          <div class="nsspac_one">
            <i
              v-show="!qrShow"
              class="iconfont wx"
              :class="{ wxActive: hoved }"
              @mouseenter="enter"
              @mouseleave="leave"
              @click="wxzf"
              >&#xe63e;</i
            >
          </div>
          <div style="color: #fff">微信登录</div>
        </div>
      </template>
      <!-- <div id="login_fater"> -->
      <div
        id="password_wx"
        :style="{
          height: qrShow ? '400px' : '0px',
          width: '250px',
          textAlign: left,
        }"
      >
        <iframe
          class="iframe"
          ref="iframe"
          src="https://open.weixin.qq.com/connect/qrconnect?appid=wx737bc9eb54d88878&scope=snsapi_login&redirect_uri=https%3A%2F%2Fwww.haixingcloud.com%3A8000%2Fapi%2Fsns%2Fcallback&state=wechat&login_type=jssdk&self_redirect=false&styletype=&sizetype=&bgcolor=&rst=&style=white&href=data:text/css;base64,QGNoYXJzZXQgInV0Zi04IjsKaWZyYW1le3dpZHRoOiAyNTBweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGV7IHdpZHRoOiAyNTBweDt9Ci53YWl0aW5nLnBhbmVsQ29udGVudHt3aWR0aDogMjUwcHg7fQouaW1wb3dlckJveCAudGl0bGUgewogICAgdGV4dC1hbGlnbjogY2VudGVyOwogICAgZm9udC1zaXplOiAyMHB4OwogICAgdGV4dC1pbmRlbnQ6IC00N3B4Owp9Ci5pbXBvd2VyQm94IC5pbmZvIHsKICAgIHdpZHRoOiAyNTBweDsKICAgIG1hcmdpbjogMCBhdXRvOwp9Ci5pbXBvd2VyQm94IC5zdGF0dXNfdHh0IHsKICAgIGRpc3BsYXk6IGlubGluZS1ibG9jazsKICAgIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7CiAgICBtYXJnaW4tcmlnaHQ6IC0xNHB4Owp9"
        ></iframe>
      </div>
      <!-- </div> -->
      <div
        id="login_container"
        :style="{
          height: qrShow ? '400px' : '0px',
          width: '250px',
          textAlign: left,
          display: 'none',
        }"
      ></div>
      <div
        class="wxupin"
        @mouseenter="enter"
        @click="qrShow = true"
        v-show="!qrShow && nwxLogin == 1"
        @mouseleave="leave"
        :class="{ active: hoved }"
      ></div>
    </el-form>
    <div v-show="clickbutton">
      <OW_PhoneNumberRegistration
        @func="hiddenAll"
        :yphone="shuru.phonea"
        :yVerification="shuru.Verification"
        :yticket="ticket"
        :yrandstr="randstr"
      ></OW_PhoneNumberRegistration>
    </div>
    <div v-show="D_ResetPassword" class="ResetPassword">
      <ResetPassword @backyzm="RPhidden"></ResetPassword>
    </div>
  </div>
</template>

<script>
import adaption from '@/mixi/adaption'
import OW_PhoneNumberRegistration from './OW_PhoneNumberRegistration'
import ResetPassword from './ResetPassword'
let Alltxid = '2075896218'
export default {
  mixins: [adaption],
  // 接收注入的数据
  inject: [
    'reload'
  ],
  components: {OW_PhoneNumberRegistration, ResetPassword},
  props: ['nwxLogin', 'yzmFalse'],
  data () {
    return {
      // 扫码登录部分
      nwxLogin_son: 1, // 1初始  2微信扫码  3验证码  4密码  5忘记密码  6绑定微信
      qrShow: false,
      qrShow_er: false,
      // 换颜色
      hoved: false,
      // 人机验证返回数据
      bizState: null,
      Alltxid,
      ticket: '',
      randstr: '',
      bLogin1: true,
      // 判断是否是充值页面从充值页面跳转过来
      flagflag: '',
      vipshuoming: true,
      // 滑块参数
      nc_token: '',
      login_button: false,
      csessionid: '',
      sig: '',
      // 发送验证按按钮
      sendstime: 60,
      disabled: false,
      sends: '获取验证码',
      checked: false,
      // type:"password",
      Return: './../../static/images/icon/Return.png',
      // 登录按钮
      flag: true,
      dlfs: '短信登录',
      // 登录方式
      flagone: false,
      flagtwo: false,
      // 输入的数据
      shuru: {
        phonea: '',
        phone: '',
        Verification: '', // 验证码
        pass: ''
      },
      // 错误的提示信息
      cuowuspan: {
        phonea: '',
        phone: '',
        Verification: '',
        pass: ''
      },
      // 标识符
      phonea: false,
      phone: false,
      Verification: false,
      pass: false,
      sceneaa: '',
      tokenen: '',
      yzmIcon: null,

      // 手机号非扫码注册
      Changebutton: 0,

      // 注册页面隐藏
      clickbutton: false,
      // 人机验证 得到的值
      randstr: '',
      ticket: '',

      // 按钮有
      anniu: false,

      // 重置密码部分
      D_ResetPassword: false
    }
  },
  created: function () {
    // 判断浏览器的宽度
    this.flagflag = this.$route.query.flag
    var that = this
  },
  methods: {
    // Refresh(){
    //   this.$refs.iframe.src = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx737bc9eb54d88878&scope=snsapi_login&redirect_uri=https%3A%2F%2Fwww.haixingcloud.com%3A8000%2Fapi%2Fsns%2Fcallback&state=wechat&login_type=jssdk&self_redirect=false&styletype=&sizetype=&bgcolor=&rst=&style=white&href=data:text/css;base64,QGNoYXJzZXQgInV0Zi04IjsKaWZyYW1le3dpZHRoOiAyNTBweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGV7IHdpZHRoOiAyNTBweDt9Ci53YWl0aW5nLnBhbmVsQ29udGVudHt3aWR0aDogMjUwcHg7fQouaW1wb3dlckJveCAudGl0bGUgewogICAgdGV4dC1hbGlnbjogY2VudGVyOwogICAgZm9udC1zaXplOiAyMHB4OwogICAgdGV4dC1pbmRlbnQ6IC00N3B4Owp9Ci5pbXBvd2VyQm94IC5pbmZvIHsKICAgIHdpZHRoOiAyNTBweDsKICAgIG1hcmdpbjogMCBhdXRvOwp9Ci5pbXBvd2VyQm94IC5zdGF0dXNfdHh0IHsKICAgIGRpc3BsYXk6IGlubGluZS1ibG9jazsKICAgIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7CiAgICBtYXJnaW4tcmlnaHQ6IC0xNHB4Owp9'
    // },
    hidden_er () {
      this.qrShow = this.$store.state.WXshutDown
      this.qrShow_er = this.$store.state.WXshutDown
      // console.log(this.qrShow,this.qrShow_er)
    },
    resetPassword () {
      this.D_ResetPassword = true
    },
    RPhidden (Back_yzm) {
      this.D_ResetPassword = Back_yzm
    },
    // 显示二维码登录
    wxzf () {
      this.qrShow = true
    },
    wxzf_er () {
      this.qrShow_er = true
    },
    hiddwxzi () {
      this.qrShow_er = false
      this.qrShow = false
    },
    enter () {
      this.hoved = true
    },
    leave () {
      this.hoved = false
    },
    showRouter () {
      // 调用reload方法，刷新整个页面
      this.reload()
    },
    vipleave () {
      this.vipshuoming = !this.vipshuoming
      this.login_button = false
      this.flagone = false
      this.flagtwo = false
    },
    // 注册返回
    hiddenAll (clickBack) {
      this.clickbutton = clickBack
      this.shuru.phonea = ''
      this.shuru.phone = ''
      this.shuru.Verification = ''
      this.shuru.pass = ''
      this.cuowuspan.pass = ''
      this.cuowuspan.phonea = ''
      this.cuowuspan.phone = ''
      this.cuowuspan.Verification = ''
    },
    send () {
      this.nc_token = this.$cookieStore.getCookie('nc_token')
      this.csessionid = this.$cookieStore.getCookie('csessionid')
      this.sig = this.$cookieStore.getCookie('sig')
      if (this.shuru.phonea == '') {
        this.cuowuspan.phonea = '请填写手机号'
        this.phonea = true
        return false
      } else {
        this.http.yzpho(this.shuru.phonea).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'false') {
              // this.cuowuspan.phonea = '您未注册，请先注册！'
              this.initTencentCaptcha().then(res => {
                this.ticket = res.ticket
                this.randstr = res.randstr
                if (res.ret === 0) {
                  this.http.SMSverification(this.shuru.phonea, 'register')
                    .then(res => {
                      if (res.data.code == 200 && res.data.message == 'ok') {
                        this.Changebutton = 2
                        this.$message({
                          message: '验证码已发送到您的手机，请注意查看',
                          type: 'success'
                        })
                        let that = this
                        let resend = setInterval(function () {
                          that.sendstime--
                          if (that.sendstime > 0) {
                            that.sends = `已发送(${that.sendstime}s)`
                            // that.sends = that.sendstime + 's后重新获取'
                            that.disabled = true
                          } else {
                            clearInterval(resend)
                            that.sends = '获取验证码'
                            that.sendstime = 60
                            that.disabled = false
                          }
                        }, 1000)
                      } else {
                        this.$message('获取验证码太频繁了')
                        let that = this
                        let resend = setInterval(function () {
                          that.sendstime--
                          if (that.sendstime > 0) {
                            that.sends = `已发送(${that.sendstime}s)`
                            that.disabled = true
                          } else {
                            clearInterval(resend)
                            that.sends = '获取验证码'
                            that.sendstime = 60
                            that.disabled = false
                          }
                        }, 1000)
                      }
                    })
                }
              })
              this.phonea = true
            } else if (res.data.message == 'true') {
              // console.log("发送验证码,然后登陆")
              this.http
                .send(this.shuru.phonea, this.nc_token, this.csessionid, this.sig)
                .then(res => {
                  // console.log(res)
                  if (res.data.code == 200) {
                    if (res.data.message == 'ok') {
                      this.Changebutton = 1
                      this.$message({
                        message: '验证码已发送到您的手机，请注意查看',
                        type: 'success'
                      })
                      var that = this
                      var resend = setInterval(function () {
                        that.sendstime--
                        if (that.sendstime > 0) {
                          that.sends = that.sendstime + 's后重新获取'
                          that.disabled = true
                        } else {
                          clearInterval(resend)
                          that.sends = '获取验证码'
                          that.sendstime = 60
                          that.disabled = false
                        }
                      }, 1000)
                    }
                  } else if (res.data.code == 400) {
                    if (res.data.message == 'failed,unable to get data') {
                      this.$message.error('不能获取到数据')
                    } else if (res.data.message == 'failed,user phone invalid') {
                      this.$message.error('手机号无效')
                    } else if (
                      res.data.message == 'failed,afs authenticate invalid'
                    ) {
                      this.$message.error('滑块验证失败')
                    }
                  } else if (res.data.code == 500) {
                    if (res.data.message == 'failed,please retry!') {
                      this.$message.error('验证码发送过于频繁，请稍后再试。，请重试！')
                    }
                  } else if (res.data.code == 403) {
                    this.$message.error('验证码发送过于频繁，请稍后再重新尝试!')
                  }
                })
            }
          } else if (res.data.code == 500) {
            this.$notify({
              title: '请联系管理员咨询',
              type: 'warning'
            })
          }
        })
      }
    },
    // 人机验证
    initTencentCaptcha (cb) {
      const _this = this
      return new Promise((resolve, reject) => {
        const TC = new TencentCaptcha(
          Alltxid,
          function (res) {
            resolve(res)
            cb && cb(res)
            if (res.ret === 0) {
              _this.ticket = res.ticket
              _this.randstr = res.randstr
              _this.bizState = res.bizState
              _this.Alltxid = res.appid
            } else if (res.ret === 2) {
              console.logh('用户关闭了')
            }
          },
          {bizState: '自定义透传参数'}
        )
        TC.show()
      })
    },
    forget () {
      this.$router.push('./Forget')
    },
    Returngo () {
      this.$router.push('./Home')
    },
    Returnasdf () {
      this.Return = './../../static/images/icon/Return1.png'
    },
    Returna () {
      this.Return = './../../static/images/icon/Return.png'
    },
    // 密码手机号
    phoneaaa () {
      if (this.shuru.phone == '') {
        this.phone = true
        this.cuowuspan.phone = '请填写手机号或用户名'
        return false
      } else {
        this.phone = false
        this.cuowuspan.phone = ''
      }
    },
    // 密码 密码
    passa () {
      if (this.shuru.pass == '') {
        this.cuowuspan.pass = '请输入密码'
        this.pass = true
        // this.flag=false
        return false
      } else {
        this.cuowuspan.pass = ''
        this.pass = false
      }
    },
    // 短信手机号
    phoneaa () {
      if (this.shuru.phonea == '') {
        this.phonea = true
        this.cuowuspan.phonea = '请填写手机号'
        this.yzmIcon = 'el-icon-error'
        // this.flag=false
        return false
      } else if (this.shuru.phonea) {
        var reg = /^1[2-9][0-9]\d{8}$/
        if (reg.test(this.shuru.phonea)) {
          this.phonea = false
          this.cuowuspan.phonea = ''
          this.yzmIcon = 'el-icon-success'
        } else {
          this.phonea = true
          this.cuowuspan.phonea = '手机号格式有误'
          this.yzmIcon = 'el-icon-error'
          return false
        }
      }
    },
    // 短信验证码
    Verificationa () {
      if (this.shuru.Verification == '') {
        this.cuowuspan.Verification = '请输入验证码'
        this.Verification = true
        return false
      } else if (this.shuru.Verification) {
        var reg = /^\d{6}$/
        if (reg.test(this.shuru.Verification)) {
          this.Verification = false
          this.cuowuspan.Verification = ''
        } else {
          this.Verification = true
          this.cuowuspan.Verification = '验证码格式有误'
          return false
        }
      }
    },
    // 登录
    // SignIn () {
    //   if(this.Changebutton == 1 || this.Changebutton == 0){
    //     if (this.flagone == true) {
    //       if (this.shuru.phone == '' || this.shuru.pass == '') {
    //         return false
    //       } else {
    //         if (this.flag == true) {
    //           this.http
    //             .denglu(this.shuru.phone, this.shuru.pass)
    //             .then(res => {
    //               if (res.status == 200 && res.data.code === 200) {
    //                 this.tokenen = res.data.data.token
    //                 this.$cookieStore.setCookie(
    //                   'user_sess',
    //                   this.tokenen,
    //                   2590000
    //                 )
    //                 this.$message({
    //                   message: '登录成功！',
    //                   type: 'success'
    //                 })
    //                 window.localStorage.setItem('state', 'logged')
    //                 if (this.flagflag == 1) {
    //                   window.location.reload()
    //                 } else {
    //                   // this.$router.push('./Center')
    //                   if(this.$store.state.client == 0){
    //                     this.$router.push('./Center')
    //                   }else if(this.$store.state.client == 1){
    //                     this.$router.push('./Pro_download')
    //                     this.$store.commit('addCount',this.tokenen)
    //                   }else if(this.$store.state.client == 2){
    //                     this.$router.push('./Center/Recharge')
    //                   }

    //                 }
    //               } else if (res.data.code === 404) {
    //                 this.$message.error('您未注册，请先注册！')
    //               } else if (res.data.code === 401) {
    //                 // this.$message.error('密码错误，请重试！0000')
    //                 this.$message.error('您的账号或密码输入有误!');
    //               } else {
    //                 this.$message.error(res.data.message)
    //               }
    //             })
    //             .catch(err => {
    //               console.log('err: ', JSON.stringify(err))
    //             })
    //         }
    //       }
    //     } else if(this.shuru.phone != '' || this.shuru.Verification != ''){

    //       if (this.shuru.phonea == '' || this.shuru.Verification == '') {
    //         return false
    //       } else {
    //         if (this.flag == true) {
    //           this.http
    //             .dxdenglu(this.shuru.phonea, this.shuru.Verification)
    //             .then(res => {
    //               console.log(res)
    //               alert(666)
    //               if (res.status == 200) {
    //                 this.tokenen = res.data.data.token
    //                 this.$cookieStore.setCookie(
    //                   'user_sess',
    //                   this.tokenen,
    //                   2590000
    //                 )
    //                 this.$message({
    //                   message: '登录成功',
    //                   type: 'success'
    //                 })
    //                 this.$router.push('./Center')
    //               }
    //             })
    //             .catch(err => {
    //               this.$message.error('账号或验证码错误，请检查')
    //             })
    //         }
    //       }
    //     }
    //   }else if(this.Changebutton == 2){
    //     // console.log('注册部分')
    //     this.http.checkPhone(this.shuru.phonea,this.shuru.Verification,'register')
    //     .then(res => {
    //       // this.clickbutton = true
    //       // console.log(res)  //判断验证码
    //       if(res.data.code == 400){
    //         this.$message.error('账号或验证码错误，请检查')
    //       }else if(res.data.code == 200){
    //         this.clickbutton = true
    //       }
    //     })
    //   }
    // },
    SignIn_Password () {
      if (this.Changebutton == 1 || this.Changebutton == 0) {
        console.log(this.flagone, this.flagtwo)
        if (this.flagone == true) {
          if (this.flag == true) {
            this.http
              .denglu(this.shuru.phone, this.shuru.pass)
              .then(res => {
                if (res.status == 200 && res.data.code === 200) {
                  this.tokenen = res.data.data.token
                  this.$cookieStore.setCookie(
                    'user_sess',
                    this.tokenen,
                    2590000
                  )
                  this.$message({
                    message: '登录成功！',
                    type: 'success'
                  })
                  if (this.$cookieStore.getCookie('user_sess') !== '' && this.$route.query.Rechargelogin !== undefined) {
                    window.location.href = `http://192.168.50.137:8002/#${this.$route.query.Rechargelogin}`
                  }
                  window.localStorage.setItem('state', 'logged')
                  if (this.flagflag == 1) {
                    window.location.reload()
                  } else {
                    this.$router.push('./Center')
                  }
                } else if (res.data.code === 404) {
                  this.$message.error('您未注册，请返回点击微信注册！')
                } else if (res.data.code === 401) {
                  this.$message.error('密码错误，请重试！')
                } else {
                  this.$message.error(res.data.message)
                }
              })
              .catch(err => {
                console.log('err: ', JSON.stringify(err))
              })
          }
        }
      } else if (this.Changebutton == 2) {
        // console.log('注册部分')
        this.http.checkPhone(this.shuru.phonea, this.shuru.Verification, 'register')
          .then(res => {
          // console.log(res)  //判断验证码
            if (res.data.code == 400) {
              this.$message.error('账号或验证码错误，请检查')
            } else if (res.data.code == 200) {
              this.clickbutton = true
            }
          })
      }
    },

    // 验证码登录 zhuce
    SignIn_YZM () {
      // this.clickbutton = true
      if (this.Changebutton == 1 || this.Changebutton == 0) {
        console.log(this.flagone, this.flagtwo)
        if (this.shuru.phonea == '' || this.shuru.Verification == '') {
          return false
        } else {
          if (this.flag == true) {
            this.http
              .dxdenglu(this.shuru.phonea, this.shuru.Verification)
              .then(res => {
                if (res.status == 200) {
                  this.tokenen = res.data.data.token
                  this.$cookieStore.setCookie(
                    'user_sess',
                    this.tokenen,
                    2590000
                  )
                  this.$message({
                    message: '登录成功',
                    type: 'success'
                  })
                  if (this.$cookieStore.getCookie('user_sess') !== '' && this.$route.query.Rechargelogin !== undefined) {
                    window.location.href = `http://192.168.50.137:8002/#${this.$route.query.Rechargelogin}`
                  }
                  this.$router.push('./Center')
                }
              })
              .catch(err => {
                this.$message.error('账号或验证码错误，请检查')
              })
          }
        }
      } else if (this.Changebutton == 2) {
        // console.log('注册部分')
        this.http.checkPhone(this.shuru.phonea, this.shuru.Verification, 'register')
          .then(res => {
          // console.log(res)  //判断验证码
            if (res.data.code == 400) {
              this.$message.error('账号或验证码错误，请检查')
            } else if (res.data.code == 200) {
              this.clickbutton = true
            }
          })
      }
    },
    pass_login () {
      this.flagone = false
      this.flagtwo = true
      this.vipshuoming = false
      this.login_button = true
    },
    sms_login () {
      this.flagone = true
      this.flagtwo = false
      this.vipshuoming = false
      this.login_button = true
    },

    // 登录方式
    mimadl () {
      if ((this.flagone == true) & (this.flagtwo == false)) {
        this.flagone = false
        this.flagtwo = true
        this.vipshuoming = false
        this.dlfs = '密码登录'
      } else {
        this.flagone = true
        this.flagtwo = false
        this.vipshuoming = false
        this.dlfs = '短信登录'
      }
    },
    Establish () {
      this.$router.push('./Register')
    },
    detectIE () {
      var ua = window.navigator.userAgent
      var msie = ua.indexOf('MSIE ')
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
      }

      var trident = ua.indexOf('Trident/')
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:')
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
      }

      var edge = ua.indexOf('Edge/')
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
      }

      // other browser
      return false
    },
    focus_botton () {
      // this.$nextTick(() => {
      //     this.$refs.elbottomnext.focus()
      //     // alert(focus)
      // })
      alert(1111)
      //  this.$nextTick(() => {
      //     setTimeout(() => {
      //       this.$refs.elbottomnext.focus()
      //     },100)
      //   })
    }
  },
  watch: {
    'nwxLogin': function () {
      this.shuru.Verification = '',
      this.shuru.pass = '',
      this.shuru.phonea = '',
      this.shuru.phone = ''
    },
    'shuru.Verification': function () {
      const that = this
      if (this.shuru.Verification == '') {
        this.anniu = false
      } else {
        this.anniu = true

        // this.$nextTick(() => {
        //   setTimeout(() => {
        //     that.$refs.elbottomnext.focus()
        //   },100)
        // })
      }
    }
  },
  beforeDestroy () {
    this.$cookieStore.delCookie('nc_token')
    this.$cookieStore.delCookie('csessionid')
    this.$cookieStore.delCookie('sig')
  }
}
</script>

<style lang="scss" scoped>
.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 24px;
}
.el-form-item,
.el-form,
.el-col {
  text-align: center;
}
.forget.el-row {
  width: 237px;
  margin: 0px auto 19px;
}
.el-form-item .el-form-item__content {
  text-align: right !important;
}
// Yang
.input_top {
  height: 60px;
  width: 100%;
  user-select: none;
  font-size: 30px;
  color: white;
  font-weight: 900;
  overflow: hidden;
  font-family: Noto Sans S Chinese Black Bold;
}
.input_top div {
  margin-top: 20px;
}
.el-col a {
  font-size: 12px !important;
  width: 60px;
  display: inline-block;
  width: 100%;
  height: 100%;
  text-align: right;
}
.wxupin {
  margin-bottom: 10px;
  font-size: 10px;
  cursor: pointer;
  display: inline-block;
}
.active {
  color: white;
}
.nsspac {
  padding-top: 30px;
}
.nsspac_one {
  width: 50px !important;
  height: 50px !important;
  margin: 0 auto 5px;
}
.yzm {
  padding-right: 15px !important;
  line-height: 0px !important;
  color: #ffffff8a;
  // width: 90px;
  height: 26px;
  position: absolute;
  top: -50px;
  right: 0;
}
.Obtain {
  padding-right: 15px !important;
  line-height: 0px !important;
  color: black !important;
  // width: 90px;
  height: 26px;
  position: absolute;
  top: -50px;
  right: 0;
  font-size: 14px;
  background-image: linear-gradient(
    270deg,
    rgba(244, 201, 29, 1) 0%,
    rgba(255, 242, 130, 1) 100%
  );
}
.el-form-item__content {
  height: 26px;
  display: inline-block;
  color: black !important;
}
button {
  margin: 0 auto !important;
  display: flex !important;
  justify-content: space-around;
  align-items: center;
  border: 1px solid transparent;
  // background-image: linear-gradient(
  //   270deg,
  //   rgba(244, 201, 29, 1) 0%,
  //   rgba(255, 242, 130, 1) 100%
  // );
}
.elbutton_pt {
  display: block;
  width: 237px;
  height: 40px;
  margin: 12px auto;
  border-radius: 5px;
  background-image: linear-gradient(
    270deg,
    rgba(244, 201, 29, 1) 0%,
    rgba(255, 242, 130, 1) 100%
  );
}
.elbutton_pt_er {
  display: block;
  width: 237px;
  height: 40px;
  margin: 12px auto;
  border-radius: 5px;
  background-color: #a6a9af !important;
  border: 1px solid #a6a9af;
  color: #ffffff8a !important;
}
.elbutton_pt_er span {
  color: #ffffff8a !important;
}
.ResetPassword {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #252e45;
  border-radius: 20px;
  z-index: 2;
}
.rpwd {
  color: #fff;
  text-align: left;
  margin-top: -15px;
  height: 25px;
  line-height: 20px;
  margin-right: 10px;
  cursor: pointer;
  width: 65px;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/base/yzm.vue